import { render, staticRenderFns } from "./paymentGateWay.vue?vue&type=template&id=a27d1aec"
import script from "./paymentGateWay.vue?vue&type=script&lang=js"
export * from "./paymentGateWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports